<ng-container>
  <form [id]="formIdent" ngNativeValidate ngNoForm (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)">
    <div [innerHTML]="sanitizedForm">
    </div>
    <div class="grid-1-auto" style="margin-top: 0.5rem">
      <div></div>
      <button type="submit" name="submitText" class="md-btn" [disabled]="forceDisable">{{submitText}}</button>
    </div>
  </form>
</ng-container>
